import { Template01 } from "../../Template/Template01";
import { data } from "./data";

export default function User() {
  return (
    <Template01
      data={data}
    ></Template01>
  );
}